import { useState } from 'react';
import LoginFormTabs from './components/LoginFormTabs';
import LoginTab from './forms/LoginTab';
import JoinBetaTab from './forms/JoinBetaTab';
import { LoginFormProps } from './types';
import './LoginForm.css';

export const LoginForm = ({
  loginTabProps,
  joinWaitlistTabProps,
  activeTab,
  onTabChange,
  prefilledEmail,
  openResetRequest,
}: LoginFormProps) => {
  // Use external state if provided, otherwise use internal state
  const [internalActiveTab, setInternalActiveTab] = useState(1);
  const activeLoginTab = activeTab !== undefined ? activeTab : internalActiveTab;
  const handleTabChange = onTabChange || setInternalActiveTab;

  return (
    <div className="login-form">
      <LoginFormTabs
        tabs={[
          { id: 'sign-in', label: 'Sign in', content: 'Welcome to Home!' },
          // { id: 'join', label: 'Join', content: 'This is your profile.' }, // Temporarily deactivated
          { id: 'join-beta', label: 'Join', content: 'Create your account!' },
        ]}
        activeTab={activeLoginTab === 2 ? 1 : activeLoginTab} // Adjust for missing tab
        onTabChange={(newTab) => {
          // Skip index 1 since Join tab is commented out
          if (newTab === 1) {
            handleTabChange(2);
          } else {
            handleTabChange(newTab);
          }
        }}
      />
      <div className="login-form-content">
        {activeLoginTab === 0 ? (
          <LoginTab
            {...loginTabProps}
            initialEmail={prefilledEmail}
            initialOpenReset={openResetRequest}
            onSwitchToJoin={(email) => handleTabChange(2, email)}
          />
        ) : (
          <JoinBetaTab
            initialEmail={prefilledEmail}
            onSwitchToSignIn={(email) => handleTabChange(0, email)}
          />
        )}
      </div>
    </div>
  );
};
